import React, { useContext } from 'react';
import { ComponentContext } from '../../contexts';
import { GenericEllipse } from '../../generic/ellipse';
import { SEAT_CIRCLE_DIAMETER, SEAT_SPACING, COLORS, SHAPE_STROKE_COLOR } from '../../constants';
import { Label } from '../../generic/label';
import { SelectionMarkerType } from '../../contexts/components-context';
import { RoundTableSeats } from './round-table-seats';
export var RoundTable = function (_a) {
    var definition = _a.definition;
    var width = definition.width, height = definition.height;
    var seatReservedSpace = SEAT_CIRCLE_DIAMETER + SEAT_SPACING;
    var ellipseDiameter = Math.max(0, width - seatReservedSpace * 2);
    var _b = useContext(ComponentContext), PointerArea = _b.PointerArea, SelectionMarker = _b.SelectionMarker;
    return (React.createElement(React.Fragment, null,
        React.createElement(GenericEllipse, { x: seatReservedSpace, y: seatReservedSpace, fill: COLORS.FILL, width: ellipseDiameter, height: ellipseDiameter, notBounding: true },
            React.createElement(Label, { color: SHAPE_STROKE_COLOR, width: ellipseDiameter, height: ellipseDiameter, angle: definition.angle }, definition.label)),
        React.createElement(SelectionMarker, { x: seatReservedSpace, y: seatReservedSpace, width: ellipseDiameter, height: ellipseDiameter, type: SelectionMarkerType.ROUND }),
        React.createElement(RoundTableSeats, { ellipseDiameter: ellipseDiameter, definition: definition }),
        React.createElement(PointerArea, { width: width, height: height })));
};
//# sourceMappingURL=round-table.js.map